<template>
  <div class="commission">

    <Examiner
      v-if="me"
      :sender="true"
      :examiner="me"/>

    <Examiner
      v-for="examiner in members"
      :examiner="examiner"
      :key="examiner.email"/>

  </div>
</template>

<script>
import Examiner from '@/components/commission/Examiner'

export default {
  name: 'Commission',
  props: {
    me: Object,
    list: Array,
  },
  components: {
    Examiner,
  },
  computed: {
    members () {
      return this.me
        ? this.list.filter(x => x.id !== this.me.id)
        : this.list
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.commission {
  display: flex;
  flex-wrap: wrap;
  margin-right: -24px;
}
</style>
